import styled from 'styled-components';
const Titles = styled.div`
display:Flex;
flex-direction:column;
padding: 0;
margin:0;
`;

export default Titles;